
import { RecentlyViewed } from '@theme/recently-viewed-products';
import { sectionRenderer } from '@theme/section-renderer';

if (!window.customElements.get('recently-viewed-products')) {
  window.customElements.define('recently-viewed-products', class RecentlyViewedProductSection extends HTMLElement {
    constructor() {
      super();
    }

    #activeFetch = null;

    connectedCallback() {
      this.productId = this.dataset.productId;
      this.sectionId = this.dataset.sectionId;
      this.designMode = this.dataset.designMode;

      this.items = this.querySelectorAll('.resource-list__item')

      if (this.designMode || this.items.length == 0) this.#removeSection();

      this.#renderRecentlyViewed();
    }

    #getRecentlyViewedProducts() {
      const viewedProducts = RecentlyViewed.getProducts();
      if (viewedProducts.length === 0) return null;

      return viewedProducts;

    }

    async #fetchProductHTML(url) {
      try {
        const response = await fetch(`${url}`, {
          headers: {
            'Cache-Control': 'max-age=600'
          }
        });

        const text = await response.text();
        return text;
      } catch (err) {
        console.error('could not fetch product card', 'reason:', err);
        return null;
      }
    }

    #extractProductCard(text, id) {
      if (id == this.productId) return null;
      const content = document.createElement('div');
      content.innerHTML = text;
      const card = content.querySelector(`product-card-link[data-product-id="${id}"]`);
      return card;
    }

    #renderRecentlyViewed = async () => {
      const viewedProducts = this.#getRecentlyViewedProducts();
      if (!viewedProducts) this.#removeSection();

      const abortController = this.#createAbortController();
      const url = new URL(Theme.routes.search_url, location.origin);
      url.searchParams.set('q', viewedProducts.map(/** @param {string} id */ (id) => `id:${id}`).join(' OR '));
      url.searchParams.set('resources[type]', 'product');

      const cards = await this.#fetchProductHTML(url);

      if (!cards) {
        this.#removeSection();
        return;
      }

      const validCards = viewedProducts
        .map(id => this.#extractProductCard(cards, id))
        .filter(Boolean);

      if (validCards.length == 0) {
        this.#removeSection();
        return;
      }
      validCards.forEach((card, index) => {
        this.items[index].innerHTML = card.outerHTML;
        this.items[index].classList.remove('product-recommendations__skeleton-item');
      });

      this.items.forEach((item) => {
        if (!item.querySelector('product-card-link')) {
          const slide = item.closest('slideshow-slide');
          if (slide) {
            slide.remove();
          } else {
            item.remove();
          }
        }
      });
    };

    #createAbortController() {
      const abortController = new AbortController();
      if (this.#activeFetch) {
        this.#activeFetch.abort();
      }
      this.#activeFetch = abortController;
      return abortController;
    }

    #removeSection() {
      const section = this.closest(`#shopify-section-${this.sectionId}`);
      if (section) section.remove();
    }

  });
}

